import { CopyWellDetail, Point } from 'business/models/CustomModels';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { CustomLayerDTO, LayerDTO } from 'business/models/Models';
import { CutCopyOperationType } from 'components/Experiment/constants';

export const setCopiedLayerPostion = (
  exp: ExperimentDtoClient,
  newCopiedLayer: LayerDTO,
  currentPlate: any,
  wellNum: number,
  diff?: Point,
) => {
  newCopiedLayer.x =
    (currentPlate.colPos - 1) * exp.containerCols +
    (wellNum % exp.containerCols == 0 ? exp.containerCols : wellNum % exp.containerCols) -
    1;
  newCopiedLayer.y =
    (currentPlate.rowPos - 1) * exp.containerRows +
    (wellNum % exp.containerCols == 0
      ? wellNum / exp.containerCols - 1
      : Math.floor(wellNum / exp.containerCols));

  const totalCols = exp.colCount * exp.containerCols;
  const totalRows = exp.rowCount * exp.containerRows;

  if (diff) {
    newCopiedLayer.x += diff.X; // copiedLayers[index].x - copiedLayers[0].x;
    newCopiedLayer.y += diff.Y; // copiedLayers[index].y - copiedLayers[0].y;
  }

  if (totalCols - newCopiedLayer.x <= newCopiedLayer.width) {
    newCopiedLayer.x = totalCols - (newCopiedLayer.width + 1);
  }
  if (totalRows - newCopiedLayer.y <= newCopiedLayer.height) {
    newCopiedLayer.y = totalRows - (newCopiedLayer.height + 1);
  }
};

export const setCopiedLayerName = (
  newCopiedLayer: LayerDTO,
  exp: ExperimentDtoClient,
  layerOperationType: CutCopyOperationType,
) => {
  const baseName = newCopiedLayer.name;
  let index = 1;

  while (true) {
    let newLayerName: string;

    if (layerOperationType === CutCopyOperationType.Copy) {
      newLayerName = `Copy(${index}) ${baseName}`;
    } else {
      newLayerName = index === 1 ? baseName : `${baseName} ${index - 1}`;
    }

    if (!exp.layers.some((e) => e.name === newLayerName)) {
      newCopiedLayer.name = newLayerName;
      break;
    }

    index++;
  }
};
export const checkConditionsAvailablity = (
  layer: LayerDTO,
  selectedWells: CopyWellDetail[],
) => {
  const maxConditionsCount = (layer.width + 1) * (layer.height + 1);
  const currentConditionsCount = (layer.layerDetail as CustomLayerDTO).condition.length;
  const availalableConditions = maxConditionsCount - currentConditionsCount;
  const ingredientsCount = selectedWells.flatMap((w) => w.wellLayers).length;
  return availalableConditions >= ingredientsCount;
};

export const getHyphenedName = (name1, name2) => {
  return [name1, name2].filter(Boolean).join('-');
};

export function formatDateWithParts(
  date: Date,
  formatParts: Intl.DateTimeFormatOptions[],
  separator: string,
): string {
  function formatWithOptions(options: Intl.DateTimeFormatOptions): string {
    const formatter = new Intl.DateTimeFormat('en', options);
    return formatter.format(date);
  }
  return formatParts.map(formatWithOptions).join(separator);
}

export const shortDayMonthYearFormat: Intl.DateTimeFormatOptions[] = [
  { day: '2-digit' },
  { month: 'short' },
  { year: '2-digit' },
];

export const shortDayMonthYearTimeFormat: Intl.DateTimeFormatOptions = {
  month: 'short', // e.g. Aug
  day: '2-digit', // e.g. 26
  year: 'numeric', // e.g. 2025
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * Convert to local time, formatted as yyyy-MM-ddThh:mm
 * @param date
 * @returns
 */
export const formatLocalDateTimeInputStr = (date: Date) => {
  const formatted = date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const [month, day, year, hour, minute] = formatted.match(/\d+/g);
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
